import type {
  FetchMembershipContractsQueryParams,
  MembershipContractTimeline
} from '@libs/data-access/entities'

import { httpServices } from '../../../../apis'
import type { QueryFnParams, PaginatedQueryResponse } from '../../../../types'

import type { MembershipContractEligibleForDPAESchema } from './types/membership.contract.schema'

export type FetchMembershipContractsOptions =
  QueryFnParams<FetchMembershipContractsQueryParams>

/**
 *
 */
export const fetchMembershipContracts = async (
  opts: FetchMembershipContractsOptions
) => {
  const response = await httpServices.core.get<
    PaginatedQueryResponse<MembershipContractTimeline, 'contracts'>
  >(
    `/employee_management/memberships/${opts?.pathParams.membership_id}/contracts`,
    { params: opts?.queryParams }
  )
  return response.data
}

export type FetchMembershipContractsEligibleForDPAEOptions = QueryFnParams<{
  pathParams: {
    membership_id: number
  }
}>

export const fetchMembershipContractsEligibleForDPAE = async (
  opts: FetchMembershipContractsEligibleForDPAEOptions
) => {
  const response =
    await httpServices.core.get<MembershipContractEligibleForDPAESchema>(
      `/employee_management/memberships/${opts?.pathParams.membership_id}/contracts/eligible_for_dpae`
    )
  return response.data
}
